import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "patient-group" }
const _hoisted_2 = ["onKeydown"]
const _hoisted_3 = { class: "patient-group__title-section" }
const _hoisted_4 = { class: "patient-group__title" }
const _hoisted_5 = { class: "patient-group__info-section" }
const _hoisted_6 = { class: "patient-group__target-response" }
const _hoisted_7 = { class: "patient-group__content" }

import type { PatientGroup } from "@virtual-care/shared";
import PatientRow from "./PatientRow.vue";

interface Props {
  group: PatientGroup;
}

interface Emits {
  (e: "toggle", groupId: string): void;
  (e: "call", patientId: string): void;
  (e: "breakthrough", patientId: string): void;
  (e: "expand-row", patientId: string): void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PatientGroupSection',
  props: {
    group: {}
  },
  emits: ["toggle", "call", "breakthrough", "expand-row"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const handleToggle = () => {
  emit("toggle", props.group.id);
};

const handleCall = (patientId: string) => {
  emit("call", patientId);
};

const handleBreakthrough = (patientId: string) => {
  emit("breakthrough", patientId);
};

const handleRowExpand = (patientId: string) => {
  emit("expand-row", patientId);
};

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "patient-group__header",
      role: "button",
      tabindex: "0",
      onClick: handleToggle,
      onKeydown: [
        _withKeys(handleToggle, ["enter"]),
        _withKeys(_withModifiers(handleToggle, ["prevent"]), ["space"])
      ]
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, _toDisplayString(__props.group.title) + " (" + _toDisplayString(__props.group.count) + ")", 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, _toDisplayString(__props.group.targetResponse), 1),
        _createVNode(_component_v_btn, {
          icon: "",
          variant: "text",
          size: "small",
          "aria-label": __props.group.isExpanded ? 'Collapse group' : 'Expand group'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.group.isExpanded ? "mdi-chevron-up" : "mdi-chevron-down"), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["aria-label"])
      ])
    ], 40, _hoisted_2),
    _createVNode(_component_v_expand_transition, null, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.group.patients, (patient) => {
            return (_openBlock(), _createBlock(PatientRow, {
              key: patient.id,
              patient: patient,
              onCall: handleCall,
              onBreakthrough: handleBreakthrough,
              onExpand: handleRowExpand
            }, null, 8, ["patient"]))
          }), 128))
        ], 512), [
          [_vShow, __props.group.isExpanded]
        ])
      ]),
      _: 1
    })
  ]))
}
}

})